window.plot_highcharts = (container, source) => {
	$.ajax({
		type: "GET",
		contentType: "application/json; charset=utf-8",
		url: 'graphs/data/' + source,
		dataType: 'json',
		success: (options) => {
				$(container).highcharts( options );
		},
		error: (result) => {
				console.error(result)
		}
	});
}
